export default __webpack_public_path__ + "static/media/07.e3f0e9f9.jpg";